// extracted by mini-css-extract-plugin
export default {"infoBox":"AppContent_infoBox__L7+ES","copyBox":"AppContent_copyBox__XqLgK","copyIcon":"AppContent_copyIcon__3CiUN","shake":"AppContent_shake__Fobs4"};